import $ from 'jquery';

var dismissKey = 'ca-cookies-dismissed';

function hideCookeiBar() {
	document.documentElement.classList.add('--cookie-no');
}

function dismissCookieMsg() {
	window.localStorage.setItem(dismissKey, '1');
	hideCookeiBar();
}

function isCookieMsgDismissed() {
	return window.localStorage.getItem(dismissKey) === '1';
}

// Hide it before we see it if it's been dismissed before
if (isCookieMsgDismissed()) {
	hideCookeiBar();
}

$(function () {
	document.getElementById('cookie-msg-dismiss').addEventListener('click', dismissCookieMsg);
});
